import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import AuthModal from './AuthModal';

export default function UserButton() {
  const { user, logout } = useAuth();
  const [showAuth, setShowAuth] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  if (!user) return (
    <>
      <button onClick={() => setShowAuth(true)} style={{
        display: 'flex', alignItems: 'center', gap: 6,
        background: 'rgba(255,255,255,0.12)', border: 'none',
        borderRadius: 20, padding: '6px 14px',
        color: '#fff', fontSize: 12, cursor: 'pointer',
      }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8"/>
          <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
        </svg>
        Увійти
      </button>
      {showAuth && <AuthModal onClose={() => setShowAuth(false)} />}
    </>
  );

  return (
    <div style={{ position: 'relative' }}>
      <button onClick={() => setShowMenu(m => !m)} style={{
        width: 34, height: 34, borderRadius: '50%',
        background: 'var(--accent2)', border: 'none',
        color: '#fff', fontSize: 13, fontWeight: 600,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer',
      }}>
        {user.name[0].toUpperCase()}
      </button>

      {showMenu && (
        <div style={{
          position: 'absolute', top: 42, right: 0,
          background: '#fff', borderRadius: 14,
          border: '1px solid var(--border)',
          boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
          padding: '8px', zIndex: 300, minWidth: 190,
        }}>
          <div style={{ padding: '8px 12px 10px', borderBottom: '1px solid var(--border)', marginBottom: 4 }}>
            <div style={{ fontSize: 13, fontWeight: 500 }}>{user.name}</div>
            <div style={{ fontSize: 11, color: 'var(--stone)', fontWeight: 300 }}>{user.email}</div>
          </div>
          {user.role === 'admin' && (
            <button onClick={() => {
              const token = localStorage.getItem('token');
              const u = localStorage.getItem('user');
              window.location.href = `https://admin.okolitsya-lentochka.com.ua?token=${token}&user=${encodeURIComponent(u)}`;
              setShowMenu(false);
            }} style={{
              display: 'flex', alignItems: 'center', gap: 8, width: '100%',
              padding: '9px 12px', border: 'none', background: 'transparent',
              fontSize: 13, cursor: 'pointer', borderRadius: 8,
              color: 'var(--accent2)', fontWeight: 500,
            }}>⚙️ Панель керування</button>
          )}
          <button onClick={() => { logout(); setShowMenu(false); }} style={{
            display: 'flex', alignItems: 'center', gap: 8, width: '100%',
            padding: '9px 12px', border: 'none', background: 'transparent',
            fontSize: 13, cursor: 'pointer', borderRadius: 8, color: 'var(--danger)',
          }}>🚪 Вийти</button>
        </div>
      )}
    </div>
  );
}
